module.exports = __webpack_public_path__ + "static/media/digioApprove.4e7a45b9.svg";